import React from 'react'

import CloseSharpIcon from '@mui/icons-material/CloseSharp'
import {IconButton} from '@mui/material'

type CloseButtonProps = {
  onClick?: any
}

const CloseButton = ({onClick}: CloseButtonProps) => {
  return (
    <IconButton aria-label='delete' onClick={onClick || undefined} size='large'>
      <CloseSharpIcon fontSize='inherit' />
    </IconButton>
  )
}
export default CloseButton
